/**
 * @file BrokerConnection.jsx
 * @description Main application interface with role-specific features
 * 
 * @section Responsibilities
 * - Manage role-based views
 * - Handle data aggregation
 * - Control real-time updates
 * - Manage user preferences
 * 
 * @section Dependencies
 * - Role Management: Access control
 * - Data Services: Information handling
 * - State Management: Global state
 * 
 * @section Integration Points
 * - Data API: Information retrieval
 * - Role System: Access control
 * - Notification System: Real-time updates
 * 
 * @section State Management
 * - dashboardData: Aggregated information
 * - loadingState: Data fetching
 * - errorState: Error handling
 * 
 * @section Events
 * - onDataUpdate: Data changes
 * - onError: Error handling
 * - onPreferenceChange: Settings updates
 * 
 * @section Props
 * @prop {String} userRole - Current user role
 * @prop {Object} permissions - User permissions
 */

import React from "react";
import SkinPage from "../../SkinPage";
import Widget from "../../widgets/Widget";
import "../../../../styles/broker-connection.css";
import getTradierURL from "../../../../utils/getTradierURL";

function BrokerConnection() {
  const redirect = (broker) => {
    const url = broker == "tradier" ? getTradierURL() : getTradierURL();

    window.open(url, "_blank");
  };

  return (
    <SkinPage>
      <Widget name={"broker-connection"}>
        <div className="heading">
          <h1 className="title">Welcome to Ad Deum Funds!</h1>
        </div>
        <p>
          Welcome to Ad Deum! Before you embark on your journey, it's essential
          to connect with your brokers to fully unlock the potential of our
          platform. Don't worry, we've got you covered every step of the way!
          Take a moment to link up with your brokers, and then let's dive into
          the exciting world of investment together. Your financial goals await!
        </p>
        <div className="cards">
          <div onClick={() => redirect("tradier")} className="dark-card">
            <img src="/assets/brokers/tradier.png" className="broker-img" />
            <div className="mt-10 btn outline-btn">Connect to Tradier</div>
          </div>
          <div onClick={() => { }} className="ml-5 dark-card">
            <img
              src="/assets/brokers/altruist.png"
              className="broker-img altruist"
            />
            <div className="mt-10 btn outline-btn">Connect to Altruist</div>
          </div>
        </div>
        <div className="mt-10 bottom-btn">
          <button className="btn primary" disabled>
            Start using Ad Deum
          </button>
          <p className="help">Need help? Contact your advisor</p>
        </div>
      </Widget>
    </SkinPage>
  );
}

export default BrokerConnection;
